import { GridColDef } from '@mui/x-data-grid';
import { IconButton, Tooltip } from '@mui/material';
import Icons from '../../../components/icons';
import StyledCheckbox from '../../common/styled/Checkbox';

export const getStaffAcademicTableColumns = (
  handleEditClick: (Id: string) => void,
  onHeaderCheckboxClick: (event: React.ChangeEvent<HTMLInputElement>) => void,
  onCellCheckboxClick: (id: string) => void,
  selectedRows: string[],
  allRowsSelected: boolean,
  isIndeterminate: boolean,
  isDeleting: boolean
): GridColDef[] => [
  {
    field: 'selectAll',
    flex: 1,
    maxWidth: 80,
    sortable: false,
    disableColumnMenu: true,
    headerAlign: 'center',
    align: 'center',
    renderHeader: () => {
      return (
        <StyledCheckbox
          checked={allRowsSelected}
          indeterminate={isIndeterminate}
          onChange={onHeaderCheckboxClick}
        />
      );
    },
    renderCell: (params) => {
      const rowId = encodeURIComponent(
        [
          params.row.grade ?? '',
          params.row.division ?? '',
          params.row.section ?? ''
        ].join('|')
      );
      return (
        <StyledCheckbox
          checked={selectedRows.includes(rowId)}
          onChange={() => onCellCheckboxClick(rowId)}
        />
      );
    }
  },
  {
    field: 'grade',
    headerName: 'Grade',
    flex: 1,
    minWidth: 160
  },
  {
    field: 'division',
    headerName: 'Division',
    minWidth: 160,
    flex: 1
  },
  {
    field: 'isClassTeacher',
    headerName: 'Class Teacher',
    minWidth: 180,
    renderCell: (params) => (params.row.isClassTeacher ? 'Yes' : '-')
  },
  {
    field: 'section',
    headerName: 'Section',
    minWidth: 180
  },
  {
    field: 'academicYear',
    headerName: 'Academic Year',
    minWidth: 180
  },
  {
    field: 'action',
    headerName: 'Action',
    sortable: false,
    filterable: false,
    headerAlign: 'center',
    align: 'center',
    disableColumnMenu: true,
    resizable: false,
    renderCell: (params) => {
      const rowId = encodeURIComponent(
        [
          params.row.grade ?? '',
          params.row.division ?? '',
          params.row.section ?? ''
        ].join('|')
      );
      return (
        <Tooltip title='Edit'>
          <IconButton
            onClick={() => handleEditClick(rowId)}
            disabled={isDeleting}
          >
            <Icons.EditBlackOutlined />
          </IconButton>
        </Tooltip>
      );
    }
  }
];
